
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[teamSchema]",
      function () {
        return require("private-next-pages/[teamSchema]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[teamSchema]"])
      });
    }
  